<template>
	<el-row v-loading="isLoading" :gutter="20">
		<template v-if="isLoading">
			<el-col
				v-loading="isLoading"
				:span="24"
				style="height: 500px; padding: 1rem; background: #ffffff"
			>
				<div class="bg-white"></div>
			</el-col>
		</template>
		<template v-else>
			<el-col
				v-loading="isLoading"
				:span="24"
				style="height: auto; padding: 1rem; background: #ffffff"
			>
				<div class="bg-white">
					<div class="text-right">
						<span
							class="link-text cursor-pointer"
							@click="viewDetails = !viewDetails"
							>{{ viewDetails ? "Hide" : "View" }} Details</span
						>
					</div>
					<div class="grid-content text-center" style="margin: 1rem 0">
						<h4 style="margin: 2.1rem 0;">Performance - By Category</h4>
						<category-insight-dashboard-graph
							:graph-values="graphValues"
							:graph-labels="graphLabels"
							:graph-colors="graphColors"
						></category-insight-dashboard-graph>
					</div>
				</div>
			</el-col>
			<category-performance-details
				v-if="viewDetails"
				:from-date="fromDate"
				:to-date="toDate"
				:view-details="viewDetails"
				:height="300"
				:dashboard-tab="dashboardTab"
				:performance-results="detailedPerformanceByLocation"
				:outlet="outlet"
				:graph-values="graphValues"
				:graph-labels="graphLabels"
				:graph-colors="graphColors"
				:audit-intermediate-categories="auditIntermediateCategories"
				:task-intermediate-categories="taskIntermediateCategories"
				:calendar-type-list="calendarTypeList"
				:outlet-lists="outletLists"
				:intermediate-category="intermediateCategory"
				:selected-type="selectedType"
				:task-categories="taskCategories"
				@closeCategoryDetailsModal="handleCloseCategoryDetailsModal"
				@changedSelectedOutlet="changedSelectedOutlet"
				@changedDateTypeView="changedDateTypeView"
				@changedFromDate="changedFromDate"
				@changedToDate="changedToDate"
				@changedSelectedAuditType="changedSelectedAuditType"
			></category-performance-details>
		</template>
	</el-row>
</template>

<script>
import { EventBus } from "../../../../../eventBus";
import { serverAddr } from "../../../../../networkConfig";
import CategoryInsightDashboardGraph from "./CategoryPerformanceDetails/CategoryInsightDashboardGraph.vue";
import CategoryPerformanceDetails from "./CategoryPerformanceDetails/CategoryPerformanceDetails.vue";
export default {
	name: "CategoryInsights",
	components: {
		CategoryPerformanceDetails,
		CategoryInsightDashboardGraph
	},
	props: {
		intermediateCategory: {
			type: String,
			default: "",
		},
		dashboardTab: {
			type: String,
			default: "audit",
		},
		fromDate: {
			type: String,
			default: "",
		},
		toDate: {
			type: String,
			default: "",
		},
		outlet: {
			type: String,
			default: null,
		},
		auditIntermediateCategories: {
			type: Array,
			required: false,
			default: () => []
		},
		taskIntermediateCategories: {
			type: Array,
			required: false,
			default: () => []
		},
		outletLists: {
			required: true,
			type: Array,
		},
		calendarTypeList: {
			required: true,
			type: Array
		},
		selectedType: {
      type: String,
      required: true,
    },
	},
	data() {
		return {
			selectedGraphValueType: "",
			performanceByLocation: [],
			detailedPerformanceByLocation: [],
			viewDetails: false,
			task_categories: [],
			isLoading: false,
			localResultData: [],
			graphValues: [],
			graphColors: [],
			graphLabels: [],
			taskCategories: [],
		};
	},
	watch: {
		intermediateCategory(newValue, oldValue) {
			this.getPerformanceByLocation();
			this.getAllPerformance();
		},
		dashboardTab(oldValue, newValue) {
			this.getPerformanceByLocation();
			this.getAllPerformance();
		},
		fromDate(newValue, oldValue) {
			this.getPerformanceByLocation();
			this.getAllPerformance();
		},
		toDate(newValue, oldValue) {
			this.getPerformanceByLocation();
			this.getAllPerformance();
		},
		outlet(newValue, oldValue) {
			this.getPerformanceByLocation();
			this.getAllPerformance();
		},
		viewDetails(newVal, oldVal) {
			if (newVal) {
				this.handleDetailedGraph();
			}
		},
	},
	mounted() {
		const self = this;
		EventBus.$on("fetchGraphDetails", function (payload) {
			self.getPerformanceByLocation();
			self.getAllPerformance();
		});

		EventBus.$on("callAllGraphs", function (payload) {
			self.getPerformanceByLocation();
			self.getAllPerformance();
		});
		EventBus.$on("insightsDateUpdated", function (payload) {
			self.getPerformanceByLocation();
			self.getAllPerformance();
		});
	},
	beforeDestroy() {
		EventBus.$off();
	},
	methods: {
		changedSelectedOutlet(event) {
			this.$emit('changedSelectedOutlet', event);
		},
		changedDateTypeView(event) {
			this.$emit('changedDateTypeViewList', event);
		},
		changedFromDate(event) {
			this.$emit('changedFromDate', event);
		},
		changedToDate(event) {
			this.$emit('changedToDate', event)
		},
		changedSelectedAuditType(event) {
			this.$emit('changedSelectedAuditType', event);
		},
		capitalizeFirstLetter(str) {
			return str
				? str.toLowerCase().split(/\s+/).map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")
				: str;
		},
		handleCloseCategoryDetailsModal() {
			this.viewDetails = false;
		},
		getAllPerformance() {
			const params = {
				basics: "outlet",
				include_dates: false,
				category_wise: true,
				include_cycle_data: false,
				start_date: this.fromDate,
				end_date: this.toDate,
				filters: {
					outlets: [],
				},
				designation: null,
				main_category: this.dashboardTab,
				intermediate_category: this.intermediateCategory,
			};
			if (this.outlet) {
				params.filters.outlets.push(this.outlet);
			}
			let url =
				this.dashboardTab == "audit"
					? "/bk_task_assignment/report/?get_all=true"
					: "/task_assignment/report/?get_all=true";
			if(this.fromDate && this.toDate) {
			this.isLoading = true;
			serverAddr
				.post(url, params)
				.then((response) => {
					const responseData = JSON.parse(response.data);
					let localResult = responseData.results;
					this.localResultData = [...localResult];
				})
				.catch((error) => {
					console.error(error);
				})
				.finally((result) => {
					this.isLoading = false;
				});
			}
		},
		excerptText(text, length = 10, clamp = "...") {
			return text
				? text.length > length
					? text.toString().slice(0, length) + clamp
					: text
				: text;
		},
		reRenderCategoryWiseGraph(data) {
			let colors = [];
			let labels = [];
			let values = [];
			let localArr = [...data];
			if(this.dashboardTab == 'audit') {
				localArr.sort((a, b) => b.yes_no_points_percentage - a.yes_no_points_percentage);
				for(let i = 0; i < localArr.length; i++) {
					colors.push('#d26300');
					labels.push(localArr[i].name);
					values.push(localArr[i].yes_no_points_percentage);
				}
			} else {
				localArr.sort((a, b) => b.completion_rate - a.completion_rate);
				for(let i = 0; i < localArr.length; i++) {
					colors.push('#d26300');
					labels.push(localArr[i].name);
					values.push(localArr[i].completion_rate);
				}
			}
			this.graphColors = [...colors];
			this.graphLabels = [...labels];
			this.graphValues = [...values];
			EventBus.$emit('reRenderGraphData', true);
		},
		handleDetailedGraph() {
			let labels = ['Location', 'Region', 'Sub Region'];
			let uniqueCategories = [...new Set(this.localResultData.map(el => el.category_name))];
			labels = [...labels, ...uniqueCategories];
			let valueArr = this.localResultData.map(el => {
				let tempObj = {
					'Location': el.name,
					'Region': el.region_name,
					'Sub Region': el.subregion_name,
				}
				let category_name = el.category_name;
				if(uniqueCategories.includes(category_name)) {
					tempObj[this.capitalizeFirstLetter(category_name)] = el.yes_no_points_percentage;
				}
				let tempArr = uniqueCategories.filter(el => el != category_name);
				for(let i = 0; i < tempArr.length; i++) {
					tempObj[tempArr[i]] = "";
				}
				return tempObj;
			});
			
			this.detailedPerformanceByLocation = {
				labels: labels,
				data: valueArr,
			};
		},
		getPerformanceByLocation() {
			if(this.fromDate && this.toDate) {
				const params = {
					basics: "category",
					include_dates: false,
					category_wise: true,
					include_cycle_data: true,
					start_date: this.fromDate,
					end_date: this.toDate,
					filters: {
						outlets: []
					},
					designation: null,
					main_category: this.dashboardTab,
					intermediate_category: this.intermediateCategory
				};
				if(this.outlet) {
					params.filters.outlets.push(this.outlet);
				}
				let url = this.dashboardTab == 'audit' ? '/bk_task_assignment/report/?get_all=true' : '/task_assignment/report/?get_all=true';
				if(this.fromDate && this.toDate) {
				this.isLoading = true;
				serverAddr.post(url, params)
					.then(response => {
						const responseData = JSON.parse(response.data);
						this.reRenderCategoryWiseGraph(responseData.results);
						this.performanceByLocation = responseData.results;
						this.taskCategories = [...new Set(responseData.results.map(el => el.name))];
					}).catch(error => {
						console.error(error);
					})
					.finally(result => {
						this.isLoading = false;
					});
				}
			}
		},
	},
};
</script>

<style scoped>
* {
	margin: 0;
	padding: 0;
}
#category-echarts-container {
	background: #ffffff;
	position: relative;
	height: 450px;
	overflow: hidden;
}
.link-text {
	color: #d26300;
	text-decoration: underline;
	font-size: 14px;
}
</style>
